import { getAnalyticalCodes } from '../../../shared/utils/comptabiliteService';

export const ANALYTICAL_CODES_REFRESH_EVENT = 'comptabilite:analytical-codes-refresh';

function mapAnalyticalRow(row) {
  const code = String(row.code || '').trim();
  const name = String(row.name || '').trim();
  return {
    value: code,
    label: name ? `${code} — ${name}` : code,
  };
}

/** Load postes / natures / unites from the same API as Plan Comptable analytical manager. */
export async function loadAnalyticalSelectOptions() {
  const [postes, natures, unites] = await Promise.all([
    getAnalyticalCodes('postes').catch(() => []),
    getAnalyticalCodes('natures').catch(() => []),
    getAnalyticalCodes('unites').catch(() => []),
  ]);
  return {
    postes: (Array.isArray(postes) ? postes : []).map(mapAnalyticalRow),
    natures: (Array.isArray(natures) ? natures : []).map(mapAnalyticalRow),
    unites: (Array.isArray(unites) ? unites : []).map(mapAnalyticalRow),
  };
}

export function dispatchAnalyticalCodesRefresh() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(ANALYTICAL_CODES_REFRESH_EVENT));
  }
}
